import DeleteIcon from '@mui/icons-material/Delete';
import {
	FormControl,
	Grid,
	IconButton,
	InputLabel,
	MenuItem,
	Select,
	TextField,
	Typography
} from '@mui/material';
import { Box } from '@mui/system';
import { values } from 'lodash';
import React from 'react';
import { DescopeSSOMappingsAttributes } from 'types/settings';

interface IAttributeMappingsRowProps {
	idpValue: string;
	value: DescopeSSOMappingsAttributes;
	onDelete: () => void;
	onUpdate: (idpValue: string, value: DescopeSSOMappingsAttributes) => void;
}

const AttributeMappingsRow: React.FC<IAttributeMappingsRowProps> = ({
	idpValue,
	value,
	onDelete,
	onUpdate
}) => (
	<Grid container mb={2} spacing={2} alignItems="center">
		<Grid item xs={12} sm={4}>
			<TextField
				fullWidth
				inputProps={{
					'data-testid': 'idp-field'
				}}
				value={idpValue}
				onChange={(e) => onUpdate(e.target.value, value)}
				label={intl.tr(
					'authMethods.SSO.user.mapping.attributes.field.idp.label'
				)}
			/>
		</Grid>
		<Grid item xs="auto" textAlign={{ xs: 'left', lg: 'center' }}>
			<Typography variant="body2">
				{intl.tr('authMethods.SSO.user.mapping.attributes.mapTo')}
			</Typography>
		</Grid>
		<Grid item xs={12} sm={4}>
			<FormControl fullWidth>
				<InputLabel id="select-user-mappings-attributes">
					{intl.tr(
						`authMethods.SSO.user.mapping.attributes.field.attribute.label`
					)}
				</InputLabel>
				<Select
					id="select-user-mappings-attributes"
					value={value || DescopeSSOMappingsAttributes.Email}
					onChange={(event) =>
						onUpdate(
							idpValue,
							event.target.value as DescopeSSOMappingsAttributes
						)
					}
					label={intl.tr(
						`authMethods.SSO.user.mapping.attributes.field.attribute.label`
					)}
				>
					{values(DescopeSSOMappingsAttributes)
						.filter((i) => i !== DescopeSSOMappingsAttributes.group)
						.map((v) => (
							<MenuItem key={v} value={v}>
								{intl.tr(`sso.descope.mappings.attributes.${v}`)}
							</MenuItem>
						))}
				</Select>
			</FormControl>
		</Grid>
		<Grid item alignItems="center" xs="auto">
			<Box display="flex" flexDirection="row" justifyItems="center">
				<IconButton
					onClick={onDelete}
					aria-label={intl.tr('button.delete')}
					data-testid="user-mappings-attributes-delete-button"
				>
					<DeleteIcon />
				</IconButton>
			</Box>
		</Grid>
	</Grid>
);

export default AttributeMappingsRow;
